module.exports = __webpack_public_path__ + "static/media/garn.d0529c3a.png";